/* Dear Alchemist storefront helpers */
(function () {
  /* Smart cart drawer update: refreshes items + footer + tier bar
     while PRESERVING the recommendations section (no flash). */
  function updateDrawerSections() {
    fetch(window.location.pathname + '?section_id=cart-drawer')
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var curItems = document.querySelector('cart-drawer-items');
        var newItems = doc.querySelector('cart-drawer-items');
        if (curItems && newItems) {
          /* 1) Tier bar */
          var curTier = curItems.querySelector('.da-tiers');
          var newTier = newItems.querySelector('.da-tiers');
          if (curTier && newTier) {
            curTier.outerHTML = newTier.outerHTML;
          } else if (newTier && !curTier) {
            curItems.insertAdjacentHTML('afterbegin', newTier.outerHTML);
          }

          /* 2) Form (cart line items only) */
          var curForm = curItems.querySelector('#CartDrawer-Form');
          var newForm = newItems.querySelector('#CartDrawer-Form');
          if (curForm && newForm) curForm.innerHTML = newForm.innerHTML;

          /* 3) Error container */
          var curErr = curItems.querySelector('#CartDrawer-CartErrors');
          if (curErr) curErr.textContent = '';

          /* 4) Custom (non-dynamic) recommendations refresh for "already in cart" filtering */
          var curCustomRec = curItems.querySelector('.cart-drawer__recommendations:not([data-fetch-url])');
          var newCustomRec = newItems.querySelector('.cart-drawer__recommendations:not([data-fetch-url])');
          if (curCustomRec && newCustomRec) {
            curCustomRec.outerHTML = newCustomRec.outerHTML;
          }
          /* Dynamic fetch-based recommendations are never touched */
        }

        /* Footer (subtotal, checkout) */
        var newFoot = doc.querySelector('.cart-drawer__footer');
        var curFoot = document.querySelector('.cart-drawer__footer');
        if (newFoot && curFoot) curFoot.innerHTML = newFoot.innerHTML;
      });

    /* Cart icon bubble */
    fetch(window.location.pathname + '?section_id=cart-icon-bubble')
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return;
        var bubble = document.getElementById('cart-icon-bubble');
        if (!bubble) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nb = doc.querySelector('.shopify-section');
        if (nb) bubble.innerHTML = nb.innerHTML;
      });
  }

  window.daUpdateCartDrawer = updateDrawerSections;

  /* ── Plan dropdown change (switch frequency or back to one-time) ── */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-da-cart-plan]');
    if (!sel) return;

    /* CRITICAL: stop the event from reaching CartDrawerItems' own onChange
       handler, which would call updateQuantity() with wrong params and
       trigger the red error banner. */
    e.stopPropagation();
    e.preventDefault();

    /* Clear any existing error immediately */
    var errEl = document.getElementById('CartDrawer-CartErrors');
    if (errEl) errEl.textContent = '';

    var wrap = sel.closest('.da-cart-plan');
    if (wrap) wrap.classList.add('is-loading');
    sel.disabled = true;

    var body = {
      line: Number(sel.dataset.line),
      quantity: Number(sel.dataset.qty),
      selling_plan: sel.value ? Number(sel.value) : ''   /* '' removes the plan */
    };
    var url = ((window.routes && window.routes.cart_change_url) || '/cart/change') + '.js';

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function () { updateDrawerSections(); })
      .catch(function () {
        sel.disabled = false;
        if (wrap) wrap.classList.remove('is-loading');
      });
  }, true);  /* useCapture = true so we intercept BEFORE the theme's bubbling handler */

  /* ── "Subscribe & save" upgrade button (event delegation) ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.da-cart-plan__upgrade');
    if (!btn || btn.disabled) return;

    e.stopPropagation();
    e.preventDefault();

    /* Clear any existing error immediately */
    var errEl = document.getElementById('CartDrawer-CartErrors');
    if (errEl) errEl.textContent = '';

    btn.disabled = true;
    btn.style.opacity = '.5';

    var url = ((window.routes && window.routes.cart_change_url) || '/cart/change') + '.js';
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        line: Number(btn.dataset.line),
        quantity: Number(btn.dataset.qty),
        selling_plan: Number(btn.dataset.planId)
      })
    })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function () { updateDrawerSections(); })
      .catch(function () {
        btn.disabled = false;
        btn.style.opacity = '';
      });
  });
})();

/* DA: "+ Add" on cart-drawer upsell rows */
(function () {
  if (customElements.get('da-cart-add')) return;
  class DaCartAdd extends HTMLElement {
    connectedCallback() {
      var btn = this.querySelector('button');
      if (!btn || btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () { add(btn); });
    }
  }
  function add(btn) {
    if (btn.disabled) return;
    var drawer = btn.closest('cart-drawer') || document.querySelector('cart-drawer');
    var label = btn.querySelector('.da-upsell__add-label');
    var fd = new FormData();
    fd.append('id', btn.dataset.variantId);
    fd.append('quantity', 1);
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.section; }));
      fd.append('sections_url', window.location.pathname);
    }
    btn.disabled = true;
    btn.classList.add('is-loading');
    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    })
      .then(function (r) { return typeof window.parseCartJSON === 'function' ? window.parseCartJSON(r) : r.json(); })
      .then(function (res) {
        if (res && res.status) { if (label) label.textContent = 'Sold out'; return; }
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'da-cart-add', productVariantId: Number(btn.dataset.variantId) });
        }
        if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents(res);
        else window.location = (window.routes && window.routes.cart_url) || '/cart';
      })
      .catch(function () { if (label) label.textContent = 'Try again'; })
      .finally(function () { btn.disabled = false; btn.classList.remove('is-loading'); });
  }
  customElements.define('da-cart-add', DaCartAdd);
})();

/* DA: arrows + progress bar for mobile swipe strips */
(function () {
  function init(nav) {
    if (nav.dataset.bound) return;
    var grid = nav.previousElementSibling;
    if (!grid) return;
    nav.dataset.bound = '1';
    var thumb = nav.querySelector('.da-strip-nav__thumb');
    var prev = nav.querySelector('[data-dir="-1"]');
    var next = nav.querySelector('[data-dir="1"]');
    function update() {
      var max = grid.scrollWidth - grid.clientWidth;
      nav.hidden = max <= 2;
      if (max <= 2) return;
      var ratio = grid.clientWidth / grid.scrollWidth;
      var pos = grid.scrollLeft / max;
      thumb.style.width = (ratio * 100) + '%';
      thumb.style.transform = 'translateX(' + (pos * (1 / ratio - 1) * 100) + '%)';
      prev.disabled = grid.scrollLeft <= 2;
      next.disabled = grid.scrollLeft >= max - 2;
    }
    function step(dir) {
      var cell = grid.firstElementChild;
      var gap = parseFloat(getComputedStyle(grid).columnGap) || 0;
      var w = cell ? cell.getBoundingClientRect().width + gap : grid.clientWidth * 0.8;
      var max = grid.scrollWidth - grid.clientWidth;
      var idx = Math.round(grid.scrollLeft / w) + dir;
      var last = Math.ceil(max / w);
      idx = Math.max(0, Math.min(last, idx));
      animateTo(Math.min(max, idx * w));
    }
    var anim = null;
    function animateTo(target) {
      if (anim) cancelAnimationFrame(anim);
      var start = grid.scrollLeft, dist = target - start, t0 = null, dur = 320;
      if (Math.abs(dist) < 1) return;
      grid.style.scrollSnapType = 'none';
      function frame(ts) {
        if (t0 === null) t0 = ts;
        var k = Math.min(1, (ts - t0) / dur);
        var e = 1 - Math.pow(1 - k, 3);
        grid.scrollLeft = start + dist * e;
        if (k < 1) { anim = requestAnimationFrame(frame); }
        else { anim = null; grid.style.scrollSnapType = ''; update(); }
      }
      anim = requestAnimationFrame(frame);
      clearTimeout(grid._daSafety);
      grid._daSafety = setTimeout(function () {
        if (anim) { cancelAnimationFrame(anim); anim = null; }
        if (Math.abs(grid.scrollLeft - target) > 1) grid.scrollLeft = target;
        grid.style.scrollSnapType = '';
        update();
      }, dur + 150);
    }
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    grid.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  function run() { document.querySelectorAll('[data-da-strip-nav]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
